export { default } from "./CharacterCard";



// WEBPACK FOOTER //
// ./src/components/CharacterCard/index.js